import Muuri from 'muuri';

export function initBlogGrid() {
  const gridEl = document.querySelector('.masonry');
  const filtersEl = document.querySelector('.blog--category');
  if (!gridEl || !filtersEl) return;

  const grid = new Muuri(gridEl, {
    items: '.item',
    layoutDuration: 350,
    layoutEasing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
    showDuration: 200,
    hideDuration: 200,
  });

  filtersEl.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-filter]');
    if (!li) return;

    const filterValue = li.getAttribute('data-filter') || '*';

    grid.filter((item) => {
      const el = item.getElement();
      if (filterValue === '*') return true;
      return el.matches(filterValue);
    });

    filtersEl.querySelectorAll('li').forEach((n) => n.classList.remove('is-active'));
    li.classList.add('is-active');
  });

  // Relayout après chargement d’images (important car tu as des thumbs + lazy)
  const relayout = () => grid.refreshItems().layout();

  window.addEventListener('load', relayout);
  gridEl.querySelectorAll('img').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', relayout, { once: true });
    img.addEventListener('error', relayout, { once: true });
  });
}